import moment from "moment"

export const customData = {
    "responseCode": {
        "msg": "List Fetched Successfully",
        "status": "Success",
        "code": 4001
    },
    "length": 0,
    "response": {
        "advertisers": [
            {
                "id": 1,
                "value": "Demo Advertiser"
            }
        ],
        "platforms": [
            {
                "id": 2,
                "value": "Meta"
            },
            {
                "id": 3,
                "value": "Google Ads"
            }
        ],
        "campaigns": [
            {
                "id": 4,
                "value": "Customer Engagement - Holiday Campaign"
            },
            {
                "id": 5,
                "value": "Brand Awareness - Festive Teaser"
            },
            {
                "id": 6,
                "value": "Website Traffic - Winter Sale"
            },
            {
                "id": 7,
                "value": "Audience Awareness - New Year Teaser"
            },
            {
                "id": 8,
                "value": "Truview Skippable - Product Launch"
            },
            {
                "id": 9,
                "value": "Reach Skippable - Seasonal Offer"
            },
        ]
    }
}

export const campaignPerformanceListTotalDatewiseOne = {
    "responseCode": {
        "msg": "List Fetched Successfully",
        "status": "Success",
        "code": 4002
    },
    "responseList": [
        {
            platformId: 2,
            sdate: '2024-10-01',
            impressions: 10699145,
            clicks: 7239,
            conversions: 0,
            spend: 13071863,
            cr: 0,
            ctr: 0.02,
            ecpm: 0,
            cpa: 0,
            cpc: 0,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 4
        },
        {
            platformId: 2,
            sdate: '2024-10-07',
            impressions: 4246357,
            clicks: 6897,
            conversions: 0,
            spend: 7869843,
            cr: 0,
            ctr: 0.5,
            ecpm: 0,
            cpa: 0,
            cpc: 0,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 4
        },
        {
            platformId: 2,
            sdate: '2024-10-13',
            impressions: 291464,
            clicks: 4106,
            conversions: 3,
            spend: 7021979,
            cr: 0.04,
            ctr: 0.25,
            ecpm: 8.24,
            cpa: 10274.33,
            cpc: 3.72,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 4
        },
        {
            platformId: 2,
            sdate: '2024-10-19',
            impressions: 1027752,
            clicks: 2024,
            conversions: 0,
            spend: 859658,
            cr: 0,
            ctr: 0.11,
            ecpm: 8.84,
            cpa: 0,
            cpc: 4.34,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 4
        },
        {
            platformId: 2,
            sdate: '2024-10-25',
            impressions: 3552569,
            clicks: 4062,
            conversions: 0,
            spend: 1187363,
            cr: 0,
            ctr: 0.05,
            ecpm: 8.46,
            cpa: 0,
            cpc: 3.97,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 4
        },
        {
            platformId: 2,
            sdate: '2024-10-31',
            impressions: 4608399,
            clicks: 9773,
            conversions: 0,
            spend: 11761446.399999999,
            cr: 0,
            ctr: 0.05,
            ecpm: 7.47,
            cpa: 0,
            cpc: 3.6,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 4
        },
        {
            platformId: 3,
            sdate: '2024-10-02',
            impressions: 6125516,
            clicks: 1140,
            conversions: 0,
            spend: 654971,
            cr: 0,
            ctr: 0.03,
            ecpm: 0,
            cpa: 0,
            cpc: 0,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 5
        },
        {
            platformId: 3,
            sdate: '2024-10-08',
            impressions: 5021539,
            clicks: 470,
            conversions: 0,
            spend: 355013,
            cr: 0,
            ctr: 0.5,
            ecpm: 0,
            cpa: 0,
            cpc: 0,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 5
        },
        {
            platformId: 3,
            sdate: '2024-10-14',
            impressions: 1547882,
            clicks: 595,
            conversions: 2,
            spend: 969157,
            cr: 0.04,
            ctr: 0.25,
            ecpm: 8.22,
            cpa: 11327.48,
            cpc: 4.08,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 5
        },
        {
            platformId: 3,
            sdate: '2024-10-20',
            impressions: 53289,
            clicks: 66,
            conversions: 0,
            spend: 828332,
            cr: 0,
            ctr: 0.2,
            ecpm: 7.94,
            cpa: 0,
            cpc: 5,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 5
        },
        {
            platformId: 3,
            sdate: '2024-10-26',
            impressions: 4387034,
            clicks: 577,
            conversions: 0,
            spend: 1069912.5653090002,
            cr: 0,
            ctr: 0.1,
            ecpm: 7.06,
            cpa: 0,
            cpc: 3.99,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 5
        },
        {
            platformId: 2,
            sdate: '2024-10-03',
            impressions: 5071982,
            clicks: 8744,
            conversions: 0,
            spend: 31926757,
            cr: 0,
            ctr: 0.04,
            ecpm: 0,
            cpa: 0,
            cpc: 0,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 6
        },
        {
            platformId: 2,
            sdate: '2024-10-09',
            impressions: 11781249,
            clicks: 10459,
            conversions: 0,
            spend: 3629290,
            cr: 0,
            ctr: 0.25,
            ecpm: 0,
            cpa: 0,
            cpc: 0,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 6
        },
        {
            platformId: 2,
            sdate: '2024-10-15',
            impressions: 3005561,
            clicks: 3341,
            conversions: 3,
            spend: 25325530,
            cr: 0.06,
            ctr: 0.11,
            ecpm: 7.46,
            cpa: 6809.92,
            cpc: 4.17,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 6
        },
        {
            platformId: 2,
            sdate: '2024-10-21',
            impressions: 6155093,
            clicks: 152,
            conversions: 3,
            spend: 758035,
            cr: 0.52,
            ctr: 0.05,
            ecpm: 6.87,
            cpa: 852.79,
            cpc: 4.45,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 6
        },
        {
            platformId: 2,
            sdate: '2024-10-27',
            impressions: 14633028,
            clicks: 17335,
            conversions: 0,
            spend: 34562920.8,
            cr: 0,
            ctr: 0.1,
            ecpm: 8.1,
            cpa: 0,
            cpc: 4.47,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 6
        },
        {
            platformId: 3,
            sdate: '2024-10-04',
            impressions: 942323,
            clicks: 3940,
            conversions: 0,
            spend: 10675831,
            cr: 0,
            ctr: 0.04,
            ecpm: 0,
            cpa: 0,
            cpc: 0,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 7
        },
        {
            platformId: 3,
            sdate: '2024-10-10',
            impressions: 975552,
            clicks: 294,
            conversions: 0,
            spend: 8962073,
            cr: 0,
            ctr: 0.31,
            ecpm: 0,
            cpa: 0,
            cpc: 0,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 7
        },
        {
            platformId: 3,
            sdate: '2024-10-16',
            impressions: 16602,
            clicks: 2148,
            conversions: 2,
            spend: 2845386,
            cr: 0.05,
            ctr: 0.25,
            ecpm: 8.13,
            cpa: 8749.93,
            cpc: 4.61,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 7
        },
        {
            platformId: 3,
            sdate: '2024-10-22',
            impressions: 62389,
            clicks: 797,
            conversions: 2,
            spend: 4183834,
            cr: 0.15,
            ctr: 0.05,
            ecpm: 7.97,
            cpa: 2615.98,
            cpc: 4.02,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 7
        },
        {
            platformId: 3,
            sdate: '2024-10-28',
            impressions: 899797,
            clicks: 5632,
            conversions: 0,
            spend: 6864693.794787001,
            cr: 0,
            ctr: 0.1,
            ecpm: 7.79,
            cpa: 0,
            cpc: 3.49,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 7
        },
        {
            platformId: 2,
            sdate: '2024-10-05',
            impressions: 44249,
            clicks: 7126,
            conversions: 0,
            spend: 5964313,
            cr: 0,
            ctr: 0.1,
            ecpm: 0,
            cpa: 0,
            cpc: 0,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 8
        },
        {
            platformId: 2,
            sdate: '2024-10-11',
            impressions: 162206,
            clicks: 23823,
            conversions: 0,
            spend: 435253,
            cr: 0,
            ctr: 0.22,
            ecpm: 0,
            cpa: 0,
            cpc: 0,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 8
        },
        {
            platformId: 2,
            sdate: '2024-10-17',
            impressions: 322830,
            clicks: 1015,
            conversions: 1,
            spend: 3954085,
            cr: 0.21,
            ctr: 0.11,
            ecpm: 8.94,
            cpa: 3172.45,
            cpc: 6.53,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 8
        },
        {
            platformId: 2,
            sdate: '2024-10-23',
            impressions: 465201,
            clicks: 14461,
            conversions: 0,
            spend: 2005322,
            cr: 0,
            ctr: 0.1,
            ecpm: 8.78,
            cpa: 0,
            cpc: 4.23,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 8
        },
        {
            platformId: 2,
            sdate: '2024-10-29',
            impressions: 1122083,
            clicks: 23726,
            conversions: 0,
            spend: 5362546.199999999,
            cr: 0,
            ctr: 0.1,
            ecpm: 8.37,
            cpa: 0,
            cpc: 4.27,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 8
        },
        {
            platformId: 3,
            sdate: '2024-10-06',
            impressions: 1674705,
            clicks: 4306,
            conversions: 0,
            spend: 30001326,
            cr: 0,
            ctr: 0.03,
            ecpm: 0,
            cpa: 0,
            cpc: 0,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 9
        },
        {
            platformId: 3,
            sdate: '2024-10-12',
            impressions: 11222,
            clicks: 2154,
            conversions: 0,
            spend: 2998193,
            cr: 0,
            ctr: 0.11,
            ecpm: 0,
            cpa: 0,
            cpc: 0,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 9
        },
        {
            platformId: 3,
            sdate: '2024-10-18',
            impressions: 1091266,
            clicks: 1043,
            conversions: 0,
            spend: 13738504,
            cr: 0,
            ctr: 0.25,
            ecpm: 8.86,
            cpa: 0,
            cpc: 5.64,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 9
        },
        {
            platformId: 3,
            sdate: '2024-10-24',
            impressions: 304189,
            clicks: 141,
            conversions: 0,
            spend: 5202704,
            cr: 0,
            ctr: 0.1,
            ecpm: 8.73,
            cpa: 0,
            cpc: 4.15,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 9
        },
        {
            platformId: 3,
            sdate: '2024-10-30',
            impressions: 1140186,
            clicks: 1836,
            conversions: 0,
            spend: 31603700.900000006,
            cr: 0,
            ctr: 0.15,
            ecpm: 7.44,
            cpa: 0,
            cpc: 3.74,
            start_video: 0,
            first_quartile: 0,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            campaginId: 9
        }
    ],
    "length": 0
}

export const campaignPerformanceListTotal = {
    "responseCode": {
        "msg": "List Fetched Successfully",
        "status": "Success",
        "code": 4002
    },
    "responseList": [
        {
            "platformId": 0,
            "impressions": 0,
            "clicks": 0,
            "conversions": 0,
            "spend": 0,
            "cr": 0.0,
            "ctr": 0.0,
            "ecpm": 0.0,
            "cpa": 0.0,
            "cpc": 0.0,
            "start_video": 0,
            "first_quartile": 0,
            "second_quartile": 0,
            "third_quartile": 0,
            "complete_view": 0,
            "vcr": 0,
            "currency": "INR"
        }
    ],
    "length": 0
}

export const geoPerformance = {
    "responseCode": {
        "msg": "List Fetched Successfully",
        "status": "Success",
        "code": 4001
    },
    "responseList": [
        {
            country: 'IN',
            countryName: 'india',
            impressions: 91442659,
            clicks: 169422,
            conversions: 0,
            ctr: 0.19,
            cr: 0,
            ecpm: 3710.98,
            cpc: 1659.95,
            cpa: 0,
            startVid: 7341765,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 276649835.66,
            advertiserId: 1,
            platformId: 2,
            campaginId: 4
        },
        {
            country: 'unknown',
            impressions: 1,
            clicks: 0,
            conversions: 0,
            ctr: 0,
            cr: 0,
            ecpm: 1265.8,
            cpc: 0,
            cpa: 0,
            startVid: 0,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 1.2658,
            advertiserId: 1,
            platformId: 3,
            campaginId: 5
        }
    ],
    "length": 0
}

export const geoPerformanceIndonesia = {
    "responseCode": {
        "msg": "List Fetched Successfully",
        "status": "Success",
        "code": 4001
    },
    "responseList": [
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Jammu and Kashmir',
            impressions: 18572998,
            clicks: 21899,
            conversions: 0,
            ctr: 0.17,
            cr: 0,
            ecpm: 3058.74,
            cpc: 1821.52,
            cpa: 0,
            startVid: 77262,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 31426192,
            advertiserId: 1,
            platformId: 2,
            campaginId: 4
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Arunachal Pradesh',
            impressions: 29928538,
            clicks: 61327,
            conversions: 0,
            ctr: 0.15,
            cr: 0,
            ecpm: 4349.39,
            cpc: 2974.72,
            cpa: 0,
            startVid: 241613,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 90158295,
            advertiserId: 1,
            platformId: 3,
            campaginId: 5
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Assam',
            impressions: 16375370,
            clicks: 9235,
            conversions: 0,
            ctr: 0.32,
            cr: 0,
            ecpm: 15944.76,
            cpc: 5061.17,
            cpa: 0,
            startVid: 23489,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 49637757,
            advertiserId: 1,
            platformId: 2,
            campaginId: 6
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Bihar',
            impressions: 326482,
            clicks: 36025,
            conversions: 0,
            ctr: 0.18,
            cr: 0,
            ecpm: 2165.63,
            cpc: 1198.52,
            cpa: 0,
            startVid: 0,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 41265431,
            advertiserId: 1,
            platformId: 3,
            campaginId: 7
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Chhattisgarh',
            impressions: 2242327,
            clicks: 3367,
            conversions: 0,
            ctr: 0.25,
            cr: 0,
            ecpm: 4704.16,
            cpc: 1918.8,
            cpa: 0,
            startVid: 300101,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 21875471,
            advertiserId: 1,
            platformId: 2,
            campaginId: 8
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Goa',
            impressions: 3707496,
            clicks: 7011,
            conversions: 0,
            ctr: 0.23,
            cr: 0,
            ecpm: 2786.44,
            cpc: 1204.81,
            cpa: 0,
            startVid: 40670,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 20266729,
            advertiserId: 1,
            platformId: 3,
            campaginId: 9
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Gujarat',
            impressions: 9382107,
            clicks: 5962,
            conversions: 0,
            ctr: 0.21,
            cr: 0,
            ecpm: 3669.11,
            cpc: 1783.63,
            cpa: 0,
            startVid: 992042,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 7107057,
            advertiserId: 1,
            platformId: 2,
            campaginId: 4
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Haryana',
            impressions: 1420728,
            clicks: 1725,
            conversions: 0,
            ctr: 0.27,
            cr: 0,
            ecpm: 3358.63,
            cpc: 1265.46,
            cpa: 0,
            startVid: 78253,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 1820771,
            advertiserId: 1,
            platformId: 3,
            campaginId: 5
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Himachal Pradesh',
            impressions: 1516378,
            clicks: 2120,
            conversions: 0,
            ctr: 0.3,
            cr: 0,
            ecpm: 2893.8,
            cpc: 971.37,
            cpa: 0,
            startVid: 49507,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 4154086,
            advertiserId: 1,
            platformId: 2,
            campaginId: 6
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Jharkhand',
            impressions: 390246,
            clicks: 609,
            conversions: 0,
            ctr: 0.2,
            cr: 0,
            ecpm: 3993.07,
            cpc: 2009.02,
            cpa: 0,
            startVid: 1150052,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 479696,
            advertiserId: 1,
            platformId: 3,
            campaginId: 7
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Karnataka',
            impressions: 781735,
            clicks: 368,
            conversions: 0,
            ctr: 0.22,
            cr: 0,
            ecpm: 3819.24,
            cpc: 1765.99,
            cpa: 0,
            startVid: 206558,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 508527,
            advertiserId: 1,
            platformId: 2,
            campaginId: 8
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Kerala',
            impressions: 53744,
            clicks: 4388,
            conversions: 0,
            ctr: 0.3,
            cr: 0,
            ecpm: 2808.05,
            cpc: 950.63,
            cpa: 0,
            startVid: 42199,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 1985039,
            advertiserId: 1,
            platformId: 3,
            campaginId: 9
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Madhya Pradesh',
            impressions: 3146102,
            clicks: 6905,
            conversions: 0,
            ctr: 0.24,
            cr: 0,
            ecpm: 2697.42,
            cpc: 1142.14,
            cpa: 0,
            startVid: 20624,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 2658069,
            advertiserId: 1,
            platformId: 2,
            campaginId: 4
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Maharashtra',
            impressions: 79669,
            clicks: 2010,
            conversions: 0,
            ctr: 0.2,
            cr: 0,
            ecpm: 5039.81,
            cpc: 2472.93,
            cpa: 0,
            startVid: 589761,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 448897,
            advertiserId: 1,
            platformId: 3,
            campaginId: 5
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Manipur',
            impressions: 430526,
            clicks: 2311,
            conversions: 0,
            ctr: 0.22,
            cr: 0,
            ecpm: 3021.59,
            cpc: 1373.53,
            cpa: 0,
            startVid: 81996,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 501384,
            advertiserId: 1,
            platformId: 2,
            campaginId: 6
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Meghalaya',
            impressions: 756287,
            clicks: 45,
            conversions: 0,
            ctr: 0.25,
            cr: 0,
            ecpm: 3284.86,
            cpc: 1334.03,
            cpa: 0,
            startVid: 190226,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 45624,
            advertiserId: 1,
            platformId: 3,
            campaginId: 7
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Mizoram',
            impressions: 287749,
            clicks: 837,
            conversions: 0,
            ctr: 0.25,
            cr: 0,
            ecpm: 2962.1,
            cpc: 1182.49,
            cpa: 0,
            startVid: 25779,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 484137,
            advertiserId: 1,
            platformId: 2,
            campaginId: 8
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Nagaland',
            impressions: 870871,
            clicks: 1434,
            conversions: 0,
            ctr: 0.21,
            cr: 0,
            ecpm: 3315.17,
            cpc: 1557.7,
            cpa: 0,
            startVid: 22460,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 347631,
            advertiserId: 1,
            platformId: 3,
            campaginId: 9
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Odisha',
            impressions: 108967,
            clicks: 822,
            conversions: 0,
            ctr: 0.23,
            cr: 0,
            ecpm: 2676.84,
            cpc: 1140.33,
            cpa: 0,
            startVid: 17249,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 550323,
            advertiserId: 1,
            platformId: 2,
            campaginId: 4
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Punjab',
            impressions: 262470,
            clicks: 340,
            conversions: 0,
            ctr: 0.26,
            cr: 0,
            ecpm: 2838.81,
            cpc: 1092.78,
            cpa: 0,
            startVid: 61593,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 291108,
            advertiserId: 1,
            platformId: 3,
            campaginId: 5
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Rajasthan',
            impressions: 221320,
            clicks: 134,
            conversions: 0,
            ctr: 0.24,
            cr: 0,
            ecpm: 3219.39,
            cpc: 1355.45,
            cpa: 0,
            startVid: 301218,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 166307,
            advertiserId: 1,
            platformId: 2,
            campaginId: 6
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Sikkim',
            impressions: 74967,
            clicks: 8,
            conversions: 0,
            ctr: 0.3,
            cr: 0,
            ecpm: 15660.34,
            cpc: 5277.02,
            cpa: 0,
            startVid: 50882,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 136193,
            advertiserId: 1,
            platformId: 3,
            campaginId: 7
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Tamil Nadu',
            impressions: 231448,
            clicks: 262,
            conversions: 0,
            ctr: 0.25,
            cr: 0,
            ecpm: 2233.15,
            cpc: 895.56,
            cpa: 0,
            startVid: 0,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 119487,
            advertiserId: 1,
            platformId: 2,
            campaginId: 8
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Telangana',
            impressions: 85485,
            clicks: 120,
            conversions: 0,
            ctr: 0.22,
            cr: 0,
            ecpm: 3315.59,
            cpc: 1498.31,
            cpa: 0,
            startVid: 195550,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 32577,
            advertiserId: 1,
            platformId: 3,
            campaginId: 9
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Tripura',
            impressions: 17472,
            clicks: 29,
            conversions: 0,
            ctr: 0.22,
            cr: 0,
            ecpm: 16875.39,
            cpc: 7501.98,
            cpa: 0,
            startVid: 124919,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 16176,
            advertiserId: 1,
            platformId: 2,
            campaginId: 4
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Uttar Pradesh',
            impressions: 43199,
            clicks: 26,
            conversions: 0,
            ctr: 0.19,
            cr: 0,
            ecpm: 2314.76,
            cpc: 1227.69,
            cpa: 0,
            startVid: 0,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 39435,
            advertiserId: 1,
            platformId: 3,
            campaginId: 5
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'Uttarakhand',
            impressions: 1455,
            clicks: 16,
            conversions: 0,
            ctr: 0.42,
            cr: 0,
            ecpm: 15165.93,
            cpc: 3614.84,
            cpa: 0,
            startVid: 41235,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 9830,
            advertiserId: 1,
            platformId: 2,
            campaginId: 6
        },
        {
            country: 'INDIA',
            countryCode: 'IN',
            state: 'West Bengal',
            impressions: 126523,
            clicks: 87,
            conversions: 0,
            ctr: 0.18,
            cr: 0,
            ecpm: 3639.21,
            cpc: 1997.47,
            cpa: 0,
            startVid: 148128,
            firstQuart: 0,
            secondQuart: 0,
            thirdQuart: 0,
            completeView: 0,
            vcr: 0,
            spend: 117606.66000002623,
            advertiserId: 1,
            platformId: 3,
            campaginId: 7
        }
    ],
    "length": 0
}

export const ageListAll = {
    "responseCode": {
        "msg": "List Fetched Successfully",
        "status": "Success",
        "code": 4001
    },
    "responseList": [
        {
            age: '18-24',
            impressions: 41084526,
            clicks: 70448,
            conversions: 0,
            spend: 94332530,
            cr: 0,
            ctr: 0.18,
            ecpm: 2528.32,
            cpa: 0,
            cpc: 1391.35,
            start_video: 11377609,
            first_quartile: 722698,
            second_quartile: 332311,
            third_quartile: 236805,
            complete_view: 167048,
            vcr: 24,
            advertiserId: 1,
            platformId: 2,
            campaginId: 4
        },
        {
            age: '25-34',
            impressions: 10427496,
            clicks: 19902,
            conversions: 0,
            spend: 81433337,
            cr: 0,
            ctr: 0.25,
            ecpm: 2331.69,
            cpa: 0,
            cpc: 933.87,
            start_video: 7952425,
            first_quartile: 946890,
            second_quartile: 491696,
            third_quartile: 377692,
            complete_view: 259876,
            vcr: 28,
            advertiserId: 1,
            platformId: 3,
            campaginId: 5
        },
        {
            age: '35-44',
            impressions: 16707807,
            clicks: 38573,
            conversions: 0,
            spend: 46235485,
            cr: 0,
            ctr: 0.2,
            ecpm: 2021.55,
            cpa: 0,
            cpc: 1002.78,
            start_video: 1751793,
            first_quartile: 163781,
            second_quartile: 68915,
            third_quartile: 49101,
            complete_view: 34775,
            vcr: 32,
            advertiserId: 1,
            platformId: 2,
            campaginId: 6
        },
        {
            age: '45-54',
            impressions: 10705275,
            clicks: 5721,
            conversions: 0,
            spend: 15544280,
            cr: 0,
            ctr: 0.2,
            ecpm: 1969.02,
            cpa: 0,
            cpc: 1001.15,
            start_video: 84058,
            first_quartile: 5930,
            second_quartile: 1828,
            third_quartile: 1071,
            complete_view: 782,
            vcr: 6,
            advertiserId: 1,
            platformId: 3,
            campaginId: 7
        },
        {
            age: '55-64',
            impressions: 5322006,
            clicks: 338,
            conversions: 0,
            spend: 7613415,
            cr: 0,
            ctr: 0,
            ecpm: 1898.71,
            cpa: 0,
            cpc: 0,
            start_video: 8,
            first_quartile: 1,
            second_quartile: 0,
            third_quartile: 0,
            complete_view: 0,
            vcr: 0,
            advertiserId: 1,
            platformId: 2,
            campaginId: 8
        },
        {
            age: '65+',
            impressions: 7195549,
            clicks: 34440,
            conversions: 0,
            spend: 31490788.660000026,
            cr: 0,
            ctr: 0,
            ecpm: 2271.03,
            cpa: 0,
            cpc: 0,
            start_video: 17,
            first_quartile: 5,
            second_quartile: 2,
            third_quartile: 1,
            complete_view: 1,
            vcr: 14,
            advertiserId: 1,
            platformId: 3,
            campaginId: 9
        }
    ],
    "length": 0
}

export const genderListAll = {
    "responseCode": {
        "msg": "List Fetched Successfully",
        "status": "Success",
        "code": 4001
    },
    "responseList": [
        {
            gender: 'FEMALE',
            impressions: 42957426,
            clicks: 46907,
            conversions: 0,
            spend: 84960662,
            cr: 0,
            ctr: 0.23,
            ecpm: 3997.94,
            cpa: 0,
            cpc: 1765.98,
            start_video: 13972846,
            first_quartile: 2644068,
            second_quartile: 1901594,
            third_quartile: 1677014,
            complete_view: 1523529,
            vcr: 1069,
            advertiserId: 1,
            platformId: 2,
            campaginId: 4
        },
        {
            gender: 'MALE',
            impressions: 3663572,
            clicks: 59036,
            conversions: 0,
            spend: 18749004,
            cr: 0,
            ctr: 0.22,
            ecpm: 3518.11,
            cpa: 0,
            cpc: 1586.83,
            start_video: 14413922,
            first_quartile: 3769652,
            second_quartile: 2595664,
            third_quartile: 2247595,
            complete_view: 1973155,
            vcr: 1035,
            advertiserId: 1,
            platformId: 3,
            campaginId: 5
        },
        {
            gender: 'UNKNOWN',
            impressions: 44821661,
            clicks: 63479,
            conversions: 0,
            spend: 172940169.66000003,
            cr: 0,
            ctr: 0.2,
            ecpm: 2499.11,
            cpa: 0,
            cpc: 1258.05,
            start_video: 125003,
            first_quartile: 9572,
            second_quartile: 3945,
            third_quartile: 2660,
            complete_view: 1894,
            vcr: 358,
            advertiserId: 1,
            platformId: 2,
            campaginId: 6
        }
    ],
    "length": 0
}

export const channelSpend = {
    "responseCode": {
        "msg": "List Fetched Successfully",
        "status": "Success",
        "code": 200
    },
    "responseList": [
        {
            "platform": "Meta",
            "spends": [
                {
                    "date": "2024-10-01",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-02",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-03",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-04",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-05",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-06",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-07",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-08",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-09",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-10",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-11",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-12",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-13",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-14",
                    "spend": 2.5258966126000002E7
                },
                {
                    "date": "2024-10-15",
                    "spend": 2.9171414274E7
                },
                {
                    "date": "2024-10-16",
                    "spend": 9220893.7815
                },
                {
                    "date": "2024-10-17",
                    "spend": 5.14905221369E7
                },
                {
                    "date": "2024-10-18",
                    "spend": 4.05544080816E7
                },
                {
                    "date": "2024-10-19",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-20",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-21",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-22",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-23",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-24",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-25",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-26",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-27",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-28",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-29",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-30",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-31",
                    "spend": 0.0
                },
                {
                    "date": "2024-11-01",
                    "spend": 0.0
                }
            ],
            "totalSpend": 1.556962044E8
        },
        {
            "platform": "GoogleAds",
            "spends": [
                {
                    "date": "2024-10-01",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-02",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-03",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-04",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-05",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-06",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-07",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-08",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-09",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-10",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-11",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-12",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-13",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-14",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-15",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-16",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-17",
                    "spend": 0.0
                },
                {
                    "date": "2024-10-18",
                    "spend": 5566521.71236788
                },
                {
                    "date": "2024-10-19",
                    "spend": 2.976401740780112E7
                },
                {
                    "date": "2024-10-20",
                    "spend": 1.1562951303312376E7
                },
                {
                    "date": "2024-10-21",
                    "spend": 5666273.4857168
                },
                {
                    "date": "2024-10-22",
                    "spend": 5679341.2073926
                },
                {
                    "date": "2024-10-23",
                    "spend": 5685647.954303724
                },
                {
                    "date": "2024-10-24",
                    "spend": 5687759.68850628
                },
                {
                    "date": "2024-10-25",
                    "spend": 5687703.283442312
                },
                {
                    "date": "2024-10-26",
                    "spend": 5690297.979675979
                },
                {
                    "date": "2024-10-27",
                    "spend": 1.075099248344229E7
                },
                {
                    "date": "2024-10-28",
                    "spend": 4429587.635433532
                },
                {
                    "date": "2024-10-29",
                    "spend": 4427609.141738905
                },
                {
                    "date": "2024-10-30",
                    "spend": 1.077234843306565E7
                },
                {
                    "date": "2024-10-31",
                    "spend": 5705193.979854733
                },
                {
                    "date": "2024-11-01",
                    "spend": 3877385.56530943
                }
            ],
            "totalSpend": 1.2095363126136364E8
        }
    ],
    "length": 0
}

export const campaignPerformanceViewStaticData = {
    "responseCode": {
        "msg": "List Fetched Successfully",
        "status": "Success",
        "code": 4002
    },
    "responseList": [
        {
            platformId: 2,
            platform: 'Meta',
            campaign: 'Customer Engagement - Holiday Campaign',
            campaignId: 4,
            impressions: 24425686,
            clicks: 34101,
            conversions: 0,
            spend: 41772152.4,
            cr: 0,
            ctr: 0.14,
            ecpm: 1710.17,
            cpa: 0,
            cpc: 1224.95,
            start_video: 22539,
            first_quartile: 2813,
            second_quartile: 962,
            third_quartile: 404,
            complete_view: 270,
            vcr: 0,
            advertiserId: 1,
            campaginId: 4
        },
        {
            platformId: 3,
            platform: 'Google Ads',
            campaign: 'Brand Awareness - Festive Teaser',
            campaignId: 5,
            impressions: 17135260,
            clicks: 2848,
            conversions: 0,
            spend: 3877385.565309,
            cr: 0,
            ctr: 0.02,
            ecpm: 17033.72,
            cpa: 0,
            cpc: 76027.17,
            start_video: 227630,
            first_quartile: 219505,
            second_quartile: 216520,
            third_quartile: 214875,
            complete_view: 213841,
            vcr: 187,
            advertiserId: 1,
            campaginId: 5
        },
        {
            platformId: 2,
            platform: 'Meta',
            campaign: 'Website Traffic - Winter Sale',
            campaignId: 6,
            impressions: 40646913,
            clicks: 40031,
            conversions: 0,
            spend: 96202532.8,
            cr: 0,
            ctr: 0.1,
            ecpm: 2366.79,
            cpa: 0,
            cpc: 2403.2,
            start_video: 19716106,
            first_quartile: 882969,
            second_quartile: 310515,
            third_quartile: 194765,
            complete_view: 148596,
            vcr: 6,
            advertiserId: 1,
            campaginId: 6
        },
        {
            platformId: 3,
            platform: 'Google Ads',
            campaign: 'Audience Awareness - New Year Teaser',
            campaignId: 7,
            impressions: 2896663,
            clicks: 12811,
            conversions: 0,
            spend: 33531817.794787,
            cr: 0,
            ctr: 0.44,
            ecpm: 11576.02,
            cpa: 0,
            cpc: 2617.42,
            start_video: 2896663,
            first_quartile: 857732,
            second_quartile: 535318,
            third_quartile: 436098,
            complete_view: 382578,
            vcr: 37,
            advertiserId: 1,
            campaginId: 7
        },
        {
            platformId: 2,
            platform: 'Meta',
            campaign: 'Truview Skippable - Product Launch',
            campaignId: 8,
            impressions: 2116569,
            clicks: 70151,
            conversions: 0,
            spend: 17721519.2,
            cr: 0,
            ctr: 3.31,
            ecpm: 8372.76,
            cpa: 0,
            cpc: 252.62,
            start_video: 1427265,
            first_quartile: 953523,
            second_quartile: 583275,
            third_quartile: 469501,
            complete_view: 313616,
            vcr: 21,
            advertiserId: 1,
            campaginId: 8
        },
        {
            platformId: 3,
            platform: 'Google Ads',
            campaign: 'Reach Skippable - Seasonal Offer',
            campaignId: 9,
            impressions: 4221568,
            clicks: 9480,
            conversions: 0,
            spend: 83544427.901267,
            cr: 0,
            ctr: 0.22,
            ecpm: 19789.9,
            cpa: 0,
            cpc: 8812.7,
            start_video: 4221568,
            first_quartile: 3508029,
            second_quartile: 2855939,
            third_quartile: 2612951,
            complete_view: 2440997,
            vcr: 796,
            advertiserId: 1,
            campaginId: 9
        }
    ],
    "length": 6
}


// data manipulation functions
const updateResponseListWithDates = (responseList, startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (start > end) {
        throw new Error("Start date must be earlier than or equal to end date.");
    }

    // Generate an array of dates within the range
    const generateDateRange = (start, end) => {
        const dates = [];
        let currentDate = new Date(start);
        while (currentDate <= end) {
            dates.push(new Date(currentDate).toISOString().split('T')[0]); // Format as YYYY-MM-DD
            currentDate.setDate(currentDate.getDate() + 1); // Increment by one day
        }
        return dates;
    };

    const dateRange = generateDateRange(start, end);
    // Ensure we limit the number of response list entries to the date range length
    const selectedEntries = responseList.slice(0, dateRange.length);

    // Assign dates from the range to the selected entries
    const updatedList = selectedEntries.map((entry, index) => ({
        ...entry,
        sdate: dateRange[index],
    }));
    return updatedList;
}

export const getDasbboardStaticData = (currentDate) => {
    const customFilterSdate = moment(currentDate, 'YYYY-MM-DD hh:mm:ss').subtract(31, 'days').format('YYYY-MM-DD'),
        customFilterEdate = moment(currentDate, 'YYYY-MM-DD hh:mm:ss').subtract(1, 'days').format('YYYY-MM-DD');

    const firstScreenDataObject = {}
    firstScreenDataObject.campaignPerformanceListTotalDatewiseOne = updateResponseListWithDates(campaignPerformanceListTotalDatewiseOne.responseList, customFilterSdate, customFilterEdate);
    firstScreenDataObject.geoPerformance = updateResponseListWithDates(geoPerformance.responseList, customFilterSdate, customFilterEdate);
    firstScreenDataObject.geoPerformanceIndonesia = updateResponseListWithDates(geoPerformanceIndonesia.responseList, customFilterSdate, customFilterEdate);
    firstScreenDataObject.channelSpend = updateResponseListWithDates(channelSpend.responseList, customFilterSdate, customFilterEdate);
    firstScreenDataObject.campaignPerformanceViewStaticData = updateResponseListWithDates(campaignPerformanceViewStaticData.responseList, customFilterSdate, customFilterEdate);
    firstScreenDataObject.ageListAll = updateResponseListWithDates(ageListAll.responseList, customFilterSdate, customFilterEdate);
    firstScreenDataObject.genderListAll = updateResponseListWithDates(genderListAll.responseList, customFilterSdate, customFilterEdate);

    return firstScreenDataObject;
}